import { Controller, useFormContext } from "react-hook-form";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { DATE_FORMAT } from "src/config";
import { useTranslation } from "react-i18next";

const RHFDateTimePicker = ({ name, label, size }) => {
  const { control } = useFormContext();
  const { t } = useTranslation();

  const onChange = (field) => (newValue) => {
    if (newValue) {
      const formattedDate = dayjs(newValue).format("MM/DD/YYYY HH:mm:ss");
      field.onChange(formattedDate);
    } else {
      field.onChange(null);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DesktopDateTimePicker
          value={field.value || null}
          onChange={onChange(field)}
          inputFormat={"DD MMM YYYY  hh:mm:ss A"}
          renderInput={(params) => (
            <TextField
              {...params}
              label={t(label)}
              size={size}
              error={!!error}
              helperText={error ? t(error?.message) : null}
            />
          )}
        />
      )}
    />
  );
};

export default RHFDateTimePicker;
